// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const igglybuff: PokeData = {
  "id": 174,
  "name": "igglybuff",
  "height": 3,
  "weight": 10,
  "base_experience": 42,
  "types": [
    PokeType.NORMAL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "sing",
    "disable",
    "defense-curl",
    "sweet-kiss",
    "charm",
    "copycat",
    "disarming-voice"
  ],
  "moves": [
    "sweet-kiss",
    "leer",
    "moonlight",
    "dazzling-gleam",
    "supersonic",
    "purification",
    "misty-terrain",
    "body-slam",
    "growl",
    "quick-attack",
    "heal-bell",
    "play-rough",
    "moonblast"
  ],
  "evolution_chain": {
    "id": 16,
    "item": null,
    "species": [
      {
        "name": "igglybuff",
        "order": 41,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "jigglypuff",
        "order": 42,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 174,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "wigglytuff",
        "order": 43,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 39,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 53.75,
    "speed": 15,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 170,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
